export const moveItemInArray = <T>(arr: T[], from: number, to: number): T[] => {
  const newArr = [...arr];
  const dir = to > from ? 1 : -1; // direction where we will move item and all items btw from and to positions

  const item = newArr.at(from);
  for (let i = from; i * dir < to * dir; i = i + dir) {
    newArr[i] = newArr.at(i + dir);
  }
  newArr[to] = item;

  return newArr;
};
